import { WImage } from '@components/atoms'
import { useState } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import styles from './ZoomImage.module.sass'

interface Props {
  image?: {
    url?: string
    imageAlt?: string
  }
  editMode?: boolean
  className?: string
}

const ZoomImage = (props: Props) => {
  const { image = undefined, editMode = false, className = '' } = props
  const [zoom, setZoom] = useState(false)

  if (!image?.url) return null

  return (
    <div
      className={`${styles.root} ${zoom ? styles['root--zoom'] : ''} ${
        editMode ? styles['root--editMode'] : ''
      } ${className}`}
    >
      <div className={styles.zoom}>
        <TransformWrapper
          initialScale={1}
          minScale={1}
          maxScale={3}
          doubleClick={{ mode: 'toggle' }}
          onTransformed={(lib) => setZoom(lib.state.scale !== 1)}
          centerOnInit={true}
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              <TransformComponent>
                <WImage
                  src={image.url}
                  maxWidth={1920}
                  maxHeight={600}
                  alt={image?.imageAlt}
                  title={image?.imageAlt}
                />
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </div>
    </div>
  )
}

export default ZoomImage
